import React from 'react'
import cx from 'classnames'
import './styles.sass'

const PaddedBlock = ({ children, className, ...props }) => (
  <div className={cx('padded-block', className)} {...props}>
    {children}
  </div>
)

export default PaddedBlock



// WEBPACK FOOTER //
// ./src/client/components/PaddedBlock/index.jsx